import React from 'react';
import Type from 'prop-types';
import {
  Drawer,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { ExitToApp as ExitToAppIcon } from '@material-ui/icons';
import { HeaderAccount } from 'components';
import { ru } from 'locale';
import useStyles from './Sidebar.styles';

const Sidebar = props => {
  const { open, account, loading, onSignOut, onClose } = props;
  const classes = useStyles();

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <div className={classes.menuList} role="presentation">
        <List disablePadding>
          <ListItemAvatar>
            <HeaderAccount account={account} loading={loading} />
          </ListItemAvatar>
          <ListItem button key={ru.signOut} onClick={onSignOut}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText
              primary={ru.signOut}
              primaryTypographyProps={{
                className: classes.menuItemText,
              }}
            />
          </ListItem>
        </List>
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  open: Type.bool.isRequired,
  account: Type.shape({
    fullName: Type.string.isRequired,
    avatar: Type.string,
    email: Type.string,
  }),
  loading: Type.bool.isRequired,
  onClose: Type.func.isRequired,
  onSignOut: Type.func.isRequired,
};

Sidebar.defaultProps = {
  account: undefined,
};

export default Sidebar;
